var _g, _rect, _g2, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_122_3495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.440918,
    width: 42.8886,
    height: 59.5675,
    rx: 5.95675,
    fill: "#AFAEB5"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_3495)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.39771,
    y: 5.95728,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "#AFAEB5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_122_3495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2635 37.2592H14.3129C13.8128 37.2592 13.5628 37.0091 13.5628 36.509V20.356C13.5628 19.8559 13.8128 19.6058 14.3129 19.6058H17.1884C17.5635 19.6058 17.8636 19.7558 18.1136 20.0559L26.2402 30.4329V20.356C26.2402 19.8559 26.4902 19.6058 26.9903 19.6058H29.9409C30.441 19.6058 30.691 19.8559 30.691 20.356V36.509C30.691 37.0091 30.441 37.2592 29.9409 37.2592H27.0653C26.6902 37.2592 26.3902 37.1091 26.1401 36.8091L18.0136 26.4821V36.509C18.0136 37.0091 17.7636 37.2592 17.2635 37.2592Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.731,
    height: 50.0434,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 36.5098 3.63422)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.69241,
    height: 47.1996,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 41.2538 18.3765)",
    fill: "white"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.99338,
    y: 6.55295,
    width: 29.7837,
    height: 45.2713,
    rx: 1.78702,
    stroke: "#728EA2",
    strokeWidth: 1.19135
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_122_3495",
    x: 0.440918,
    y: -1.19135,
    width: 42.8885,
    height: 61.9502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_122_3495"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_122_3495"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_122_3495"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_122_3495",
    result: "effect2_innerShadow_122_3495"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_122_3495",
    x: 13.5627,
    y: 19.6058,
    width: 17.1283,
    height: 18.6533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_122_3495"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_3495"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.39771,
    y: 5.95728,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.5c32b932f43db78dffb5fdc0374696e6.svg";
export { ForwardRef as ReactComponent };